<template>
  <div :class="productPage != 'true' ? 'maps' : ''">
    <div
      dir="ltr"
      id="map"
      :class="
        productPage == 'true' ? 'mapContainerProduct' : 'mapContainerHome'
      "
    ></div>
  </div>
</template>
<script>
// import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
export default {
  props: ["lat", "lng", "marker", "productPage", "divId"],
  components: {
    // LMap,
    // LTileLayer,
    // LMarker
  },
  //   data () {
  //     return {
  //       url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  //       attribution:
  //         '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  //       zoom: 15,
  //       center: [51.505, -0.159],
  //       markerLatLng: [51.504, -0.159]
  //     };
  //   },
  mounted() {
    //create map with id of map and setting longitude and latitude and zoom
    if (window.innerWidth < 768) {
      this.map = L.map("map").setView(
        [31.2354072, 29.9642289],
        //zoom
        16
      );
    } else {
      this.map = L.map("map").setView(
        [this.lat, this.lng],
        //zoom
        16
      );
    }
    //icon of the marker
    const myIcon = L.icon({
      iconUrl: "/images/location-2.svg",
    });
    //change map according to the shape in https://leaflet-extras.github.io/leaflet-providers/preview/
    L.tileLayer("https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png", {
      attribution:
        'Map <a href="https://memomaps.de/">memomaps.de</a> <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);
    //     L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    //       attribution:
    //         '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    //     }).addTo(this.map);
    // if there is more than one marker
    this.marker.forEach((element) => {
      L.marker([element.lat, element.lng], {
        icon: myIcon,
      }).addTo(this.map);
    });
    // var markers = document.getElementsByClassName(
    //   'leaflet-popup-content',
    // );
    // for (let index = 0; index < markers.length; index++) {
    //   const element = markers[index];
    //   element.classList.add('cursor-pointer');
    // }
    // this.mountLinkUrl(markers);
  },
};
</script>
<style lang="scss">
.mapContainerHome {
  height: 45dvh;
  width: 100%;
  display: table;
  margin: 0 auto;
  z-index: 1 !important;
}
@media (width < 768px) {
  .mapContainerHome {
    height: calc(100dvh - 57px);
  }
}
.maps {
  width: 100vw;
  margin: 0 auto;
  overflow: hidden;
}

.leaflet-control-container {
  display: none !important;
}
.leaflet-marker-icon {
  width: 40px !important;
  animation-name: bouncee !important;
  animation-duration: 4s !important;
  animation-iteration-count: 50 !important;
  transition: all 2s ease !important;
}

@keyframes bouncee {
  0% {
    transform: scale3d(0.7) !important;
  }
  100% {
    transform: scale3d(1.3) !important;
  }
}
</style>
